import React from 'react';
import 'moment/locale/de';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {DatePicker, LocalizationProvider,} from '@mui/x-date-pickers';

const DatePickerComponent = props => {
  const { setSelectedDate, selectedDate, labelType, datePickerId, disabled, readOnly } = props;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      locale='de'
    >
      <DatePicker

        disabled={disabled}
        readOnly={readOnly}
        id={datePickerId}
        label={labelType}

        format="DD/MM/YYYY"

        slotProps={{
          textField: {
            'data-testid': 'datepicker--keyboard',
            size: 'small',
            variant: 'standard',
            id: datePickerId,
            label: labelType,
            margin: 'normal',
            color: 'secondary',
            disabled: disabled || readOnly,
            inputProps: {
              'aria-label': 'change date',
            }
          },
        }}

        value={moment(selectedDate)}
        onChange={setSelectedDate}
      />
    </LocalizationProvider >
  );
};

export default DatePickerComponent;
